import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const adminApi = (password) =>
  axios.create({
    baseURL: API,
    headers: { "X-Admin-Password": password },
  });

export const MEDIA = {
  hero: "https://static.prod-images.emergentagent.com/jobs/03c52390-5cf0-4b63-8c52-b6bfaff9febc/images/193cbfda06c5856d2e9fb1a367f572ebded7c2584479415ff593084f6c4dc0f0.png",
  card: "https://customer-assets.emergentagent.com/job_cemetery-clean/artifacts/1w5bzv48_Screenshot%202026-07-14%20at%204.00.46%E2%80%AFPM.png",
  before: "https://customer-assets.emergentagent.com/job_cemetery-clean/artifacts/tdzitsd9_Guest_Elisha_after_blurred.jpeg",
  after: "https://customer-assets.emergentagent.com/job_cemetery-clean/artifacts/tgweteuv_Guest_Elisha_before_blurred.jpeg",
  process: "https://static.prod-images.emergentagent.com/jobs/03c52390-5cf0-4b63-8c52-b6bfaff9febc/images/83f8f09d061ac30bb315baefdd16f90421522afdbbc1b3188b14d84a5000231a.png",
};
